// DocumentationVideoCarousel.js
import React from 'react';
import { Container, Header, Segment, Button, Embed, Icon } from 'semantic-ui-react';
import Slider from 'react-slick';
import classes from "./FootersPages.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';

export default function DocumentationVideoCarousel() {
  const { t } = useTranslation();

  const videos = [
    { title: t('documentation_video_carousel.video_titles.step1'), id: "7dQNFMCj1q8" },
    { title: t('documentation_video_carousel.video_titles.step1'), id: "7dQNFMCj1q8" },
    { title: t('documentation_video_carousel.video_titles.step1'), id: "7dQNFMCj1q8" },
    { title: t('documentation_video_carousel.video_titles.step1'), id: "7dQNFMCj1q8" },
  ];
  //   const videos = [
  //   { title: t('documentation_video_carousel.video_titles.step1'), id: "7dQNFMCj1q8" },
  //   { title: t('documentation_video_carousel.video_titles.step2'), id: "yourYoutubeVideoID2" },
  //   { title: t('documentation_video_carousel.video_titles.step3a'), id: "yourYoutubeVideoID3" },
  //   { title: t('documentation_video_carousel.video_titles.step3b'), id: "yourYoutubeVideoID4" },
  // ];

  

  // Custom arrow components
  const NextArrow = ({ onClick }) => (
    <div className={classes.nextArrow} onClick={onClick}>
      <Icon name="arrow right" size="big" />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div className={classes.prevArrow} onClick={onClick}>
      <Icon name="arrow left" size="big" />
    </div>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <Container className={classes.documentationCarousel} style={{ padding: '3em 0em' }}>
      <Segment basic textAlign="center">
        <Header as="h1" style={{ fontSize: '2.5em', color: '#2a2a2a' }}>{t('documentation_video_carousel.header')}</Header>
        <p style={{ fontSize: '1.33em', color: '#5a5a5a', marginBottom: '2em' }}>
          {t('documentation_video_carousel.description')}
        </p>
      </Segment>

      <Slider {...settings}>
        {videos.map((video, index) => (
          <Segment key={index} basic textAlign="center">
            {/* <Header as="h2" style={{ fontSize: '2em', color: '#2a2a2a' }}>{video.title}</Header> */}
            <Embed
              id={video.id}
              source="youtube"
              active
              placeholder={`path/to/placeholder-${index}.jpg`} // Optional placeholders
            />
          </Segment>
        ))}
      </Slider>

      <Segment basic textAlign="center" style={{ marginTop: '2em' }}>
        <Button primary href="/signup">{t('documentation_video_carousel.get_started_button')}</Button>
      </Segment>
    </Container>
  );
}